import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { AntimalwareAntiTamperingPanelDataProviderFactory } from '../factory/AntimalwareAntiTamperingPanelDataProviderFactory';
import { AntimalwareAntiTamperingPanelBaseDataProvider } from '../dataProvider/AntimalwareAntiTamperingPanelBaseDataProvider';
import { AntimalwareAntiTamperingPanelWebComponentSchema } from '../types';

export class AntimalwareAntiTamperingPanelRepository extends BaseWebComponentRepository {
  public dataProviderFactory: AntimalwareAntiTamperingPanelDataProviderFactory;
  public dataProvider: AntimalwareAntiTamperingPanelBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new AntimalwareAntiTamperingPanelDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<AntimalwareAntiTamperingPanelWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }
}
